import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Server from "../Server.js";
import Header from "../Header.js";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { OverlayPanel } from "primereact/overlaypanel";

import { Route, Link, Navigate } from "react-router-dom";
import { Checkbox } from "primereact/checkbox";
import { SelectButton } from "primereact/selectbutton";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";

import { Toast } from "primereact/toast";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { ProgressSpinner } from "primereact/progressspinner";

class Travel extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      AirPortList: [],
      departureDate: new Date(),
      returnDate: new Date(),
      Side: "one",
      Type: "iran",
      number: 1,
      url: this.Server.getUrl(),
      childNum: 0,
      kidNum: 0,
      adultNum: 1,
    };
    this.toast = React.createRef();

  }
  componentDidMount() {
    //this.getAirPort();
    this.getAirPorts()
  }

  getAirPorts() {
    let that = this;
    this.Server.send(
      "https://ansarcrm.iran.liara.run/AdminApi/GetCodes"/* "http://localhost:3000/AdminApi/GetCodes"*/,
      {id:["22"]},
      function (response) {
        let AirPorts = [];
        if (response.data.result[0] && response.data.result[0].values) {
          response.data.result[0].values.map((item) => {
            AirPorts.push({
              label: item.desc,
              value: item.value,
            });
          });
        }
        that.setState({
          ShowLoading: false,
          AirPorts: AirPorts,
        });
      },
      function () {
        that.setState({
          ShowLoading: false,
        });
      },
      true
    );
  }


  getAirPort() {
    let that = this;
    this.Server.send(
      "TravelApi/hiholiday_getAirPort",
      {},
      function (response) {
        let AirPorts = [];
        if (response.data.result && response.data.result.Regions) {
          response.data.result.Regions.map((item) => {
            AirPorts.push({
              label: `${item.FaRegionName} (${item.Code})`,
              value: item.Code,
            });
          });
        }

        that.setState({
          ShowLoading: false,
          AirPorts: AirPorts,
        });
      },
      function () {
        that.setState({
          ShowLoading: false,
        });
      }
    );
  }

  render() {
    if (this.state.goToSearch) {
      let path = "";
      if (this.state.returnDate.year)
        path = `/TravelSearch?p=1&firstAirPort=${this.state.firstAirPort}&lastAirPort=${this.state.lastAirPort}&number=${this.state.number}&departureDate=${this.state.departureDate.year}-${this.state.departureDate.month}-${this.state.departureDate.day}&departureDate=${this.state.departureDate.year}-${this.state.departureDate.month}-${this.state.departureDate.day}&returnDate=${this.state.returnDate.year}-${this.state.returnDate.month}-${this.state.returnDate.day}`;
      else
        path = `/TravelSearch?p=1&firstAirPort=${this.state.firstAirPort}&lastAirPort=${this.state.lastAirPort}&number=${this.state.number}&departureDate=${this.state.departureDate.year}-${this.state.departureDate.month}-${this.state.departureDate.day}&departureDate=${this.state.departureDate.year}-${this.state.departureDate.month}-${this.state.departureDate.day}`;
      return <Navigate to={path} />;
    }
    return (
      <div style={{ height: "100%" }} className="Air">
        <Toast
          ref={this.toast}
          position="top-right"
          style={{ fontFamily: "iranyekanwebmedium", textAlign: "right" }}
        />

        <Header ComponentName="سفر" ComponentLName="app-icon-15" />

        {!this.state.ShowLoading ? (
          <div
            className="sarv-bg1 sarv-home-top-box"
            style={{ height: "100%", direction: "rtl" }}
          >
            <div style={{ marginBottom: 30, paddingTop: 10 }}>
              <SelectButton
                className="sarv-select-button blue"
                value={this.state.Type}
                onChange={(e) => {
                  this.setState({
                    Type: e.value || "iran",
                  });
                }}
                options={[
                  {
                    value: "other",
                    label: "پرواز خارجی",
                  },
                  {
                    value: "iran",
                    label: <span><span><img src="./icons/travel/air.png" style={{width:30,display:'none'}} /></span><span>پرواز داخلی</span></span>,
                  },
                ]}
              />
            </div>
            {this.state.Type === "iran" && (
              <div>
                <div>
                  <SelectButton
                    className="select-button-space-between orange"
                    value={this.state.Side}
                    onChange={(e) => {
                      this.setState({
                        Side: e.value || "one",
                      });
                    }}
                    options={[
                      {
                        value: "two",
                        label: <span><span>رفت و برگشت</span>< i className="pi pi-arrow-right-arrow-left" style={{transform:'rotate(90deg)'}} /></span>,
                      },
                      {
                        value: "one",
                        label: <span><span>رفت</span>< i className="pi pi-arrow-up" /></span>,
                      },
                    ]}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                    padding: 20,
                  }}
                >
                  <Dropdown
                    value={this.state.firstAirPort}
                    style={{ width: "100%", marginBottom: 30 }}
                    filter
                    options={this.state.AirPorts}
                    onChange={(e) => {
                      this.setState({
                        firstAirPort: e.value,
                      });
                    }}
                    placeholder={<div><span className="pi pi-map-marker"></span><span>مبدا (شهر)</span></div>}
                  />
                  <div
                    style={{
                      border: "1px solid #eee",
                      padding: "0px 10px",
                      background: "#fff",
                      position: "absolute",
                      zIndex: 2,
                    }}
                  ></div>
                  <Dropdown
                    value={this.state.lastAirPort}
                    style={{ width: "100%" }}
                    filter
                    options={this.state.AirPorts}
                    onChange={(e) => {
                      this.setState({
                        lastAirPort: e.value,
                      });
                    }}
                    placeholder={<div><span className="pi pi-map-marker"></span><span>مقصد (شهر)</span></div>}
                  />
                </div>
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      textAlign: "right",
                      padding: 20,
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      position:'relative'
                    }}
                    className="DatePicker Air"
                  >
                    <DatePicker
                      date={this.state.departureDate}
                      format={"DD-MM-YYYY"}
                      onChange={(value) => {
                        this.setState({ departureDate: value });
                      }}
                      locale="fa"
                      inputPlaceholder="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;تاریخ رفت"
                      style={{ zIndex: 1000 }}
                      formatInputText={() => {
                        if (!this.state.departureDate.day) return "";
                        return ` ${this.state.departureDate.day} / ${this.state.departureDate.month} / ${this.state.departureDate.year} `;
                      }}
                    />
                    <div style={{position:'absolute',zIndex:1000,top:32,right:32}}><span className="pi pi-calendar"></span></div>
                  </div>
                  {this.state.Side == "two" && (
                    <div
                      style={{
                        textAlign: "right",
                        padding: 20,
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                      className="DatePicker Air"
                    >
                      <DatePicker
                        date={this.state.returnDate}
                        format={"DD-MM-YYYY"}
                        onChange={(value) => {
                          this.setState({ returnDate: value });
                        }}
                        locale="fa"
                        formatInputText={() => {
                          if (!this.state.returnDate.day) return "";
                          return ` ${this.state.returnDate.day} / ${this.state.returnDate.month} / ${this.state.returnDate.year} `;
                        }}
                        inputPlaceholder="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;تاریخ برگشت"
                        />
                    <div style={{position:'absolute',zIndex:1000,top:32,right:32}}><span className="pi pi-calendar"></span></div>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                    padding: 20,
                  }}
                >
                  <InputText
                    placeholder="تعداد و نوع مسافر"
                    value={`${
                      this.state.adultNum +
                      this.state.kidNum +
                      this.state.childNum
                    } مسافر`}
                    onClick={(e) => this.number.toggle(e)}
                    style={{ width: "100%" }}
                  />
                  <OverlayPanel
                    ref={(el) => (this.number = el)}
                    showCloseIcon
                    style={{ width: "90%" }}
                    className="overlaypanel-demo Air"
                  >
                    <ul
                      style={{
                        direction: "rtl",
                        listStyle: "none",
                        padding: 0,
                      }}
                    >
                      <li>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                minWidth: 120,
                                alignItems: "center",
                              }}
                            >
                              <span className="black-circle"></span>
                              <span style={{ marginRight: 10, marginLeft: 5 }}>
                                بزرگسال
                              </span>
                              <span style={{ color: "#ccc", fontSize: 12 }}>
                                12 سال به بالا
                              </span>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="Air"
                          >
                            <InputNumber
                              style={{ fontFamily: "iranyekanwebmedium" }}
                              inputId="horizontal"
                              min={1}
                              value={this.state.adultNum}
                              onValueChange={(e) => {
                                this.setState({
                                  adultNum: e.value,
                                });
                              }}
                              showButtons
                              buttonLayout="horizontal"
                              decrementButtonClassName="p-button p-component p-button-rounded p-button-text p-button-icon-only"
                              incrementButtonClassName="p-button p-component p-button-rounded p-button-text p-button-icon-only"
                              incrementButtonIcon="pi pi-plus"
                              decrementButtonIcon="pi pi-minus"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                minWidth: 120,
                                alignItems: "center",
                              }}
                            >
                              <span
                                className="black-circle"
                                style={{ width: 15, height: 15 }}
                              ></span>
                              <span style={{ marginRight: 10, marginLeft: 5 }}>
                                کودک
                              </span>
                              <span style={{ color: "#ccc", fontSize: 12 }}>
                                2 تا 12 سال
                              </span>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="Air"
                          >
                            <InputNumber
                              style={{ fontFamily: "iranyekanwebmedium" }}
                              inputId="horizontal"
                              min={0}
                              value={this.state.kidNum}
                              onValueChange={(e) => {
                                this.setState({
                                  kidNum: e.value,
                                });
                              }}
                              showButtons
                              buttonLayout="horizontal"
                              decrementButtonClassName="p-button p-component p-button-rounded p-button-text p-button-icon-only"
                              incrementButtonClassName="p-button p-component p-button-rounded p-button-text p-button-icon-only"
                              incrementButtonIcon="pi pi-plus"
                              decrementButtonIcon="pi pi-minus"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                minWidth: 120,
                                alignItems: "center",
                              }}
                            >
                              <span
                                className="black-circle"
                                style={{ width: 10, height: 10 }}
                              ></span>
                              <span style={{ marginRight: 10, marginLeft: 5 }}>
                                نوزاد
                              </span>
                              <span style={{ color: "#ccc", fontSize: 12 }}>
                                10 روز تا 2 سال
                              </span>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="Air"
                          >
                            <InputNumber
                              style={{ fontFamily: "iranyekanwebmedium" }}
                              inputId="horizontal"
                              min={0}
                              value={this.state.childNum}
                              onValueChange={(e) => {
                                this.setState({
                                  childNum: e.value,
                                });
                              }}
                              showButtons
                              buttonLayout="horizontal"
                              decrementButtonClassName="p-button p-component p-button-rounded p-button-text p-button-icon-only"
                              incrementButtonClassName="p-button p-component p-button-rounded p-button-text p-button-icon-only"
                              incrementButtonIcon="pi pi-plus"
                              decrementButtonIcon="pi pi-minus"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </OverlayPanel>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    label="جستجو"
                    className="p-button-info"
                    style={{ width: "94%" }}
                    onClick={() => {
                      if(!this.state.firstAirPort){
                        this.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">فرودگاه مبدا را وارد کنید</div>, life: 8000 });
                        return;
                      }
                      if(!this.state.lastAirPort){
                        this.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">فرودگاه مقصد را وارد کنید</div>, life: 8000 });
                        return;
                      }
                      this.setState({
                        goToSearch: true,
                      });
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(Travel);
